import { Box, Button } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { FirstStepFormData } from "../../schemas/validationSchemas";

export const SeasonSwitch = () => {
  const { watch, setValue } = useFormContext<FirstStepFormData>();
  const operatingMonths = watch("operatingMonths") || [];

  
  const allMonths = [
    "jan",
    "feb",
    "mar",
    "apr",
    "may",
    "jun",
    "jul",
    "aug",
    "sep",
    "oct",
    "nov",
    "dec",
  ];
  const extendedMonths = ["nov", "dec", "jan", "feb", "mar"];
  const summerMonths = ["dec", "jan", "feb"];

  
  const getCurrentSeason = () => {
    if (operatingMonths.length === 12) return "FULL_YEAR";
    if (
      operatingMonths.length === extendedMonths.length &&
      extendedMonths.every((month) => operatingMonths.includes(month))
    )
      return "EXTEND_SEASON";
    if (
      operatingMonths.length === summerMonths.length &&
      summerMonths.every((month) => operatingMonths.includes(month))
    )
      return "SUMMER";
    return "CUSTOM";
  };

  const currentSeason = getCurrentSeason();

  const setFullSeason = () => {
    setValue("operatingMonths", allMonths);
  };

  const setExtendedSeason = () => {
    setValue("operatingMonths", extendedMonths);
  };

  const setSummerSeason = () => {
    setValue("operatingMonths", summerMonths);
  };

  return (
    <Box
      mt={2}
      sx={{
        padding: 2,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "fit-content",
      }}
    >
      <Box sx={{ display: "flex", gap: 0.2 }}>
        <Button
          variant={"contained"}
          color={currentSeason === "FULL_YEAR" ? "primary" : "secondary"}
          onClick={setFullSeason}
          sx={{
            color: "black",
            borderRadius: 0,
          }}
        >
          FULL YEAR
        </Button>
        <Button
          color={currentSeason === "EXTEND_SEASON" ? "primary" : "secondary"}
          variant="contained"
          sx={{
            color: "black",
            borderRadius: 0,
          }}
          onClick={setExtendedSeason}
        >
          EXTEND SEASON
        </Button>
        <Button
          color={currentSeason === "SUMMER" ? "primary" : "secondary"}
          variant="contained"
          sx={{
            color: "black",
            borderRadius: 0,
          }}
          onClick={setSummerSeason}
        >
          SUMMER
        </Button>
        <Button
          color={currentSeason === "CUSTOM" ? "primary" : "secondary"}
          variant="contained"
          sx={{
            color: "black",
            borderRadius: 0,
          }}
          onClick={() => {
            
          }}
        >
          CUSTOM
        </Button>
      </Box>
    </Box>
  );
};
